/**
 * Generic "coming soon" placeholder shown for sections whose page
 * component hasn't landed yet. Lets the sidebar render and routing
 * work even before every controller + page is implemented.
 */
export function Placeholder({
  title,
  description,
}: {
  readonly title: string;
  readonly description?: string;
}) {
  return (
    <>
      <header className="nw-page-header">
        <h1 className="nw-page-header__title">{title}</h1>
      </header>
      <div className="nw-placeholder">
        <h2 className="nw-placeholder__title">Coming soon</h2>
        <p>
          {description ??
            'This section is part of the comprehensive dashboard build and will land in a follow-up slice.'}
        </p>
      </div>
    </>
  );
}
